import { toZonedTime } from "date-fns-tz";
import {
  GoogleDriveConfig,
  SFTPAuthMethod,
} from "../../dataServices/exports/types";
import { RepeatMode } from "./dateUtils";

export enum ExportTimeMode {
  Now = "now",
  Later = "later",
}

export enum ExportFormPage {
  SelectColumns = 1,
  ConfigureExport = 2,
}

export type BulkExportFormType = {
  selectedColumns: { [key: string]: boolean };
  exportName: string;
  options: {
    questionKeysAsHeaders: boolean;
    exportSelectAnswerValues: boolean;
  };
  emailEnabled: boolean;
  sftp: {
    enabled: boolean;
    config?: {
      host: string;
      port: number;
      username: string;
      authMethod: SFTPAuthMethod;
      secret: string;
      path: string;
    };
  };
  googleDrive: {
    enabled: boolean;
    config?: GoogleDriveConfig;
  };
  exportTime: {
    mode: ExportTimeMode;
    presetTime?: string; // Date ISO string or "custom"
    customTime?: string; // Date ISO string
    repeat?: {
      enabled: boolean;
      mode?: RepeatMode;
    };
    adjustForDST?: boolean;
  };
};

export function getSelectedTime(values: BulkExportFormType) {
  const presetTime = values.exportTime?.presetTime;
  const customTime = values.exportTime?.customTime;
  const selectedTimeString = presetTime === "custom" ? customTime : presetTime;
  return selectedTimeString ? new Date(selectedTimeString) : undefined;
}

export function getSelectedTimeInTimezone(
  values: BulkExportFormType,
  timezoneName: string
) {
  const selectedTime = getSelectedTime(values);
  return selectedTime ? toZonedTime(selectedTime, timezoneName) : undefined;
}
